import appConstants from '@/plugins/constants';

const AR_TASK_TYPE = appConstants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;

export function isAccountReconciliationTaskType(taskType) {
  return taskType === AR_TASK_TYPE;
}

/**
 * @param {object} source
 * @param {string} [taskType]
 * @returns {boolean}
 */
export function resolveEnforceThreshold(source = {}, taskType) {
  const effective = taskType ?? source.task_type;
  const hasTaskType = effective != null && effective !== '';
  if (hasTaskType && !isAccountReconciliationTaskType(effective)) {
    return false;
  }
  if (typeof source.enforceThreshold === 'boolean') {
    return source.enforceThreshold;
  }
  if (typeof source.skipValidations === 'boolean') {
    return !source.skipValidations;
  }
  return true;
}

export function isReconValidationSkipped(source = {}, taskType) {
  return !resolveEnforceThreshold(source, taskType);
}

/**
 * @param {boolean} enforceThreshold
 * @param {string} taskType
 * @returns {boolean}
 */
export function normalizeEnforceThresholdForTaskType(taskType, enforceThreshold) {
  if (isAccountReconciliationTaskType(taskType)) {
    return enforceThreshold === true;
  }
  return false;
}
